import React from "react"
import { getMediaUrl } from "../../utils/media"

function LandingFeaturedImage({
  landingFeaturedImageImage,
  landingFeaturedImageOrVideo,
  landingFeaturedImageVimeoId,
}) {
  return (
    <section className="landing-featured-image section-spacing-lg bg-white">
      <div className="content-block">
        {landingFeaturedImageOrVideo === false ? (
          <>
            {landingFeaturedImageImage &&
              getMediaUrl(landingFeaturedImageImage) && (
                <img
                  width="100%"
                  height="100%"
                  src={getMediaUrl(landingFeaturedImageImage)}
                  alt={landingFeaturedImageImage.altText || ""}
                  title={landingFeaturedImageImage.title || ""}
                />
              )}
          </>
        ) : (
          <>
            <div className="landing-featured-image-video__wrapper">
              <iframe
                src={`https://player.vimeo.com/video/${landingFeaturedImageVimeoId}?badge=0&autopause=0&player_id=0app_id=58479&title=0&byline=0&portrait=0`}
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                title="Go for more | Hampshire Trust Bank (HTB)"
              />
            </div>
          </>
        )}
      </div>
    </section>
  )
}

export default LandingFeaturedImage
